// Permissões de um usuário: padrão do perfil + concedidas − retiradas (catálogo em suporte-app/app/permissoes.py).
// Abre pelo botão "Permissões" na janela do usuário (Usuários → editar). Só com a permissão usuarios.gerenciar.
import React, { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import {
  Button, Checkbox, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography,
} from "@material-ui/core";

import suporteApi, { mensagemErro } from "./api";
import { carregarPermissoes } from "./permissoes";

const NOME_PERFIL = { admin: "Administrador", supervisor: "Supervisor", user: "Usuário" };

const PermissoesUsuario = ({ userId, open, onClose }) => {
  const [cat, setCat] = useState(null);
  const [dados, setDados] = useState(null);
  const [marcadas, setMarcadas] = useState(new Set());
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    if (!open || !userId) return;
    setDados(null);
    Promise.all([suporteApi.get("/api/permissoes/catalogo"), suporteApi.get(`/api/permissoes/usuarios/${userId}`)])
      .then(([c, u]) => { setCat(c.data); setDados(u.data); setMarcadas(new Set(u.data.efetivas)); })
      .catch((e) => { toast.error(mensagemErro(e)); onClose(); });
  }, [open, userId]); // eslint-disable-line react-hooks/exhaustive-deps

  const perfil = dados?.perfil;
  const padrao = useMemo(() => new Set((cat?.itens || []).filter((i) => i.padrao[perfil]).map((i) => i.chave)), [cat, perfil]);
  const admin = perfil === "admin";

  const salvar = async (concede, retira) => {
    setSalvando(true);
    try {
      const { data } = await suporteApi.put(`/api/permissoes/usuarios/${userId}`, { concede, retira });
      setDados(data);
      setMarcadas(new Set(data.efetivas));
      carregarPermissoes(true); // se for o próprio usuário, o menu atualiza
      toast.success("Permissões salvas");
    } catch (e) {
      toast.error(mensagemErro(e));
    }
    setSalvando(false);
  };
  const salvarMarcadas = () => salvar([...marcadas].filter((k) => !padrao.has(k)), [...padrao].filter((k) => !marcadas.has(k)));
  const alterou = dados && (dados.efetivas.length !== marcadas.size || dados.efetivas.some((k) => !marcadas.has(k)));
  const ajustes = [...marcadas].filter((k) => !padrao.has(k)).length + [...padrao].filter((k) => !marcadas.has(k)).length;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth scroll="paper">
      <DialogTitle>
        {dados ? `Permissões · ${dados.nome}` : "Permissões"}
        {dados && (
          <Typography variant="body2" color="textSecondary">
            {`Perfil ${NOME_PERFIL[perfil] || perfil} · ${marcadas.size} de ${cat?.itens.length || 0} permissões`
              + (ajustes ? ` · ${ajustes} ajuste(s) em relação ao padrão do perfil` : " · igual ao padrão do perfil")}
          </Typography>
        )}
      </DialogTitle>
      <DialogContent dividers>
        {!dados || !cat ? <CircularProgress size={24} /> : (
          <>
            {admin && (
              <Typography variant="body2" style={{ background: "rgba(0,0,0,.05)", padding: 8, borderRadius: 6, marginBottom: 10 }}>
                Administrador tem sempre todas as permissões (para ninguém ficar sem acesso a Usuários).
                Para limitar, troque o perfil para Supervisor ou Usuário e ajuste aqui.
              </Typography>
            )}
            {cat.grupos.map((g) => (
              <div key={g} style={{ marginBottom: 12 }}>
                <Typography variant="subtitle2" style={{ marginBottom: 2 }}>{g}</Typography>
                {cat.itens.filter((i) => i.grupo === g).map((i) => {
                  const on = marcadas.has(i.chave);
                  const doPadrao = padrao.has(i.chave);
                  const origem = on === doPadrao ? null : on ? "concedida" : "retirada";
                  return (
                    <div key={i.chave} style={{ display: "flex", alignItems: "center", gap: 6 }}>
                      <Checkbox size="small" color="primary" checked={on} disabled={admin}
                        onChange={(e) => {
                          const n = new Set(marcadas);
                          if (e.target.checked) n.add(i.chave); else n.delete(i.chave);
                          setMarcadas(n);
                        }} />
                      <span style={{ flex: 1 }}>{i.descricao}</span>
                      {origem && (
                        <Chip size="small" label={origem}
                          style={{ background: origem === "concedida" ? "#e3f2fd" : "#ffebee", color: origem === "concedida" ? "#1565c0" : "#c62828" }} />
                      )}
                      <Typography variant="caption" color="textSecondary" style={{ width: 230, textAlign: "right" }}>
                        {`padrão: ${["admin", "supervisor", "user"].filter((p) => i.padrao[p]).map((p) => NOME_PERFIL[p]).join(", ")}`}
                      </Typography>
                    </div>
                  );
                })}
              </div>
            ))}
          </>
        )}
      </DialogContent>
      <DialogActions>
        {dados && !admin && (
          <Button disabled={salvando || !ajustes} onClick={() => salvar([], [])} style={{ marginRight: "auto" }}>
            Voltar ao padrão do perfil
          </Button>
        )}
        <Button onClick={onClose}>Fechar</Button>
        {!admin && (
          <Button color="primary" variant="contained" disabled={salvando || !alterou} onClick={salvarMarcadas}>Salvar permissões</Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default PermissoesUsuario;
